// IE Hub - Simple Loading Screen Component
// Static loading screen with primary background color for general loading states
// use this component when you need to show a full page loading screen for any page
import { Box, Typography, LinearProgress } from '../ui';

interface SimpleLoadingScreenProps {
  title?: string;
  subtitle?: string;
  reviewImageSize?: number;
  sourceImage?: string;
}

const SimpleLoadingScreen: React.FC<SimpleLoadingScreenProps> = ({
  title = 'Loading....',
  reviewImageSize = 180,
  sourceImage = '/assets/loading/ieLogo.png'
}) => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'primary.main', // Using theme primary color
        gap: 3,
        px: 3,
        position: 'relative'
      }}
    >
      <Box
        component="img"
        src={sourceImage}
        alt="IE Hub"
        sx={{
          width: 'auto',
          height: reviewImageSize,
        
        }}
      />

      {/* Bottom loading message and bar */}
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 48,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          px: 4
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'white', 
            textAlign: 'center'
          }}
        >
          {title}
        </Typography>
        <Box sx={{ width: '100%', maxWidth: 420 }}>
          <LinearProgress 
            variant="indeterminate"
            sx={{
              height: 6,
              borderRadius: 4,
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'white'
              }
            }}
          />
        </Box>
      </Box>

      {/* Background Pattern/Decoration */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.05,
          backgroundImage: 'radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          zIndex: 0,
          pointerEvents: 'none'
        }}
      />
    </Box>
  );
};

export default SimpleLoadingScreen;

